import React, { ChangeEvent, useEffect, useState } from 'react'
import {Button, FormField, Loader, SubCover, SubmitModal} from '../..'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../reducers/store';
import { adminValidateUsername } from '../../validations/admins/register';
import { actionUpdateAdmin } from '../../../actions/admins';
import toast from 'react-hot-toast';
import { create } from '../../../assets';

import './editAdminUsername.css'

interface PostDataParams {
  username: string;
}

const EditAdminUsername = ({id, details}: any) => {
  const pageName                                     = "Edit Admin"
  const dispatch                                     = useDispatch<AppDispatch>();
  const [hideShow, setHideShow]                      = useState<boolean>(false);
  const [savingInfo, setSavingInfo]                  = useState<boolean>(false);
  const [fileNames, setFileNames]                    = useState<{ [key: string]: string }>({});
  const [onOpen, setOnOpen]                          = useState<boolean>(false);
  const [usernameErrors, setUsernameErrors]          = useState<string[]>([]);
  const [openSubMegaMenu, setOpenSubMegaMenu]        = useState<boolean>(false);
  const [isButtonDisabled, setIsButtonDisabled]      = useState<boolean>(true);
  const [errorMessage, setErrorMessage]              = useState<string>();
  const { getAllAdmins, currentPage }                = useSelector((state: RootState) => state.adminList);

  const [postData, setPostData]                   = useState<PostDataParams>({username: details?.username || ''})
  const [isLoadingBtn, setIsLoadingBtn]           = useState({username: false});
  const [isValid, setIsValid]                     = useState({username: false});

  const useDebounce = <T,>(value: T, delay: number): T => {
    const [debounced, setDebounced] = useState(value);
  
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebounced(value);
      }, delay);
      return () => clearTimeout(handler);
    }, [value, delay]);
  
    return debounced;
  };

  const debouncedPostData = useDebounce<PostDataParams>(postData, 500);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setIsLoadingBtn((prevState) => ({ ...prevState, [name]: true }));
    setPostData((prevState) => ({ ...prevState, [name]: value }));
  }

  // useEffect(() => {
  //   dispatch(actionFetchAdmins({currentPage})); // You can pass the page number as needed
  // }, [dispatch, currentPage]);

  useEffect(() => {
    const validateUsername = () => {
      const { isValid, errors } = adminValidateUsername({ postData: debouncedPostData, getAllAdmins });
      setIsValid((prevState) => ({
        ...prevState,
        username: isValid,
      }));
      setUsernameErrors(errors)
      setIsLoadingBtn((prevState) => ({
        ...prevState,
        username: false,
      }));
      return errors;
    };

    const usernameErrors         = validateUsername();
    
    setUsernameErrors(usernameErrors);

    const hasFormErrors = usernameErrors.length > 0;
    setIsButtonDisabled(hasFormErrors);
  }, [debouncedPostData]);

  const handleModalSubmit = () => {
    setOnOpen(true)
    setOpenSubMegaMenu(true)
  }

  const handleCloseCover = () => {
    setOnOpen(false) // modal
    setOpenSubMegaMenu(false)
  }

  const handleSubmit = async(e: ChangeEvent<any>) => {
    e.preventDefault();
    handleModalSubmit()
  }

  const cancelPostCreation = () => {
    setOnOpen(false); // Close the modal
    setSavingInfo(false);
    setOpenSubMegaMenu(false)
  };

  const confirmPostCreation = async() => {
    setSavingInfo(true);
    setIsButtonDisabled(true);
    const res = await dispatch(actionUpdateAdmin({id, postData}))
    try{
      if (res.success === true) {
        toast.success("user updated successfully");
        setPostData({username: res?.data?.username || ''})
        setSavingInfo(false);
      } else if (res?.status === 500) {
        setErrorMessage(res?.message);
        setSavingInfo(false)
      }
    }catch(error: any){
      setErrorMessage("Internal server Error")
      setSavingInfo(false)
    }
  }

  return (
    <>
      <title>{pageName}</title>
      <div className='edit-detail-admin-username-container'>
        <form className='' onSubmit={handleSubmit} autoComplete="off" >
          <div className='edit-detail-admin-username-title'>
            <h3>update Admin Username</h3>
          </div>

          <div className=''>
            <FormField inputType type="text" labelName="Username" name="username" value={postData.username} handleChange={handleChange} isLoadingBtn={isLoadingBtn.username} isValid={isValid.username} errors={usernameErrors || []} />

            <SubmitModal onOpen={onOpen} onClose={cancelPostCreation} onConfirm={confirmPostCreation} modalImage={create} prompt="Are you sure you want to update admin" />
            <Button onClickButton buttonClickWrap={savingInfo ? `button-login-submitted` : `button-login-submit`} onClickName={savingInfo ? <>{<Loader />} updating data...</> : "Update Admin"} isButtonDisabled={isButtonDisabled} buttonClasses={savingInfo ? ['button-disabled'] : (isButtonDisabled ? ['buttonDisabledClass'] : ['buttonEnabledClass'])} disabled={savingInfo} />
            
            {errorMessage && (
              <div className="form-response-message">
              <p className="error-msg">{errorMessage}</p>
              </div>
            )}
          </div>
        </form>
      </div>

      {openSubMegaMenu && (
        //z-index: 3, others should be higher
        <SubCover handleCloseCover={handleCloseCover} />
      )}
    </>
  )
}

export default EditAdminUsername